// Based on your final design
const layout = {
  minHeight: 940,
  maxWidth: 1440,
  footerHeight: 70,
  headerHeight: 100,
  marginContainer: 24,
  layoutId: 'app-root',
};

const text = {
  blackColor: '#000',
  whiteColor: '#fff',
  errorColor: '#ff0000',
  blueColor: '#1c87c6',
  grayColor: '#818181',
};

const backgroundColor = {
  button: '#2185E8',
  buttonRed: '#B71D21',
  whiteRGBA: (value: number) => `rgba(255, 254, 252, ${value})`,
  grayRGBA: (value: number) => `rgba(227, 227, 227, ${value})`,
};

const textSize = {
  xs: '0.75rem',
  sm: '0.875rem',
  base: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  xxl: '1.5rem',
  xxxl: '2.5rem',
};

const theme = {
  layout,
  text,
  backgroundColor,
  textSize,
};

export const colors = {
  default: '#828282',
  black: '#232323',
  red: '#B71D21',
  'red-semi-light': '#FF7F7F',
  'red-light': '#dc2626',
  'gray-semilight': '#F2F2F2',
  'gray-light': '#EEEEEE',
  'gray-semi': '#D3D3D3',
  gray: '#B6B6B6',
  'gray-2': '#7F7F7F',
  'gray-3': '#DEDEDE',
  'gray-4': '#AFB3B6',
  background: '#707070',
  'gray-dark': '#5B5B5B',
  'blue-link': '#3E9FFF',
  blue: '#2185E8',
  'blue-light': '#40a9ff',
  'blue-semi-light': '#A6DAF4',
  yellow: '#F9C438',
  'yellow-light': '#ffee3b',
  'yellow-alt': '#EBBE33',
  white: '#ffffff',
  'chart-red': '#DE2228',
  'chart-blue': '#4383D9',
  'white-gray': '#FAFAFA',
  unselected: '#dbdbdb',
  brown: '#4E0500',
};

export type AppTheme = typeof theme;

export default theme;
